<template>
    <div class=" py-4 px-3 ">
      <div  class="flex  justify-end">
       <button
       @click="$emit('open-cash-modal')"
       class=" rounded bg-primary-yellow px-3 py-2">
       {{ cashoutStatus }}
       </button>
      </div>
        <div class="w-full">
            <EarnPayoutFilterTable
            @getStatusProps="getStatusProps"
            :show-modal="showFilterModal"
            @close-modal="showFilterModal = false"
          />
        </div>
    </div>
  </template>
  
  <script>
  import EarnPayoutFilterTable from "../modals/EarnPayoutFilterTable.vue";
  export default {

    props:{
        openPriceInfo: {
            type: Function
        },
        currentTier:{
          type: Object
        },
    },
     data() {
      return {
        cstats: true,
        cashoutStatus: "",
        showFilterModal: false,
        startDate: "",
        endDate: "",
        searchString: "",
      };
    },
    mounted() {
    this.getCashoutStatus()
  },
    components: {
      EarnPayoutFilterTable,
    },
    computed: {
      sortProps() {
        return {
          startDate: this.startDate || null,
          endDate: this.endDate || null,
          searchString: this.searchString,
        };
      },
    },
    methods: {
        async getCashoutStatus() {
          let response = await this.$_getPendingCashout()
          if (response?.data?.hasPendingCashout === false) {
            this.cashoutStatus = "Cashout"
          } else  {
            this.cashoutStatus = "Processing"
          }
        },
   
      getStatusProps(val){
         this.$emit('setStatusChanges', val)
      }
    },
    watch: {
      sortProps() {  
        if(this.startDate < this.endDate){
          this.$emit("setQueryparams", this.sortProps);
        }
        else if(!this.startDate && !this.endDate){
          this.$emit("setQueryparams", this.sortProps);
        }
      },
    },
  
   
  };
  </script>
  
  <style lang="scss" scoped>
  .action_contain{
    @apply w-full md:w-7/12 flex items-center md:justify-end md:flex-nowrap flex-wrap;
  }
  .price_item{
    @apply text-blue-600 px-2 border-l-[1px] border-l-gray-300 flex items-center mb-2 sm:mb-0 cursor-pointer
  }
  .price_contain{
    @apply flex items-center md:w-auto w-full text-[15px] my-3 md:my-0 flex-wrap
  }
 
</style>
  